
import { z } from 'zod'

import { zodErrorParser } from '@/utils/zod'
import { BaseEntitySchema } from './Common'

export const ServiceTypes = [
  'EMAIL_NOTIFICATIONS',
  'PUSH_NOTIFICATIONS',
  'WEB_TEXT_CRAWLER',
  'IMAGE_CRAWLER',
  'THUMBNAIL_CRAWLER',
] as const

export type ServiceType = (typeof ServiceTypes)[number]

const ServiceTypeResponseSchema = BaseEntitySchema.extend({
  id: z.number(),
  type: z.enum(ServiceTypes),
}).strict()

const ServiceSettingsResponseSchema = BaseEntitySchema.extend({
  id: z.uuid(),
  organization: z.object({
    id: z.uuid(),
  }),
  service: ServiceTypeResponseSchema,
  value: z.boolean()
}).strict()

export type ServiceSettingsResponse = z.infer<typeof ServiceSettingsResponseSchema>

export const zodServiceSettingResponseValidator = (
  data: ServiceSettingsResponse[]
) => zodErrorParser(
  'ServiceSettingResponse',
  ServiceSettingsResponseSchema,
  data,
)
